import React, { useEffect, useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Table, Tr, Td } from '../../components/ui/Table';
import { Badge } from '../../components/ui/Badge';
import { getWallet, getTransactions } from '../../api/wallet';
import { Wallet, WalletTransaction } from '../../types';
import { formatCurrency, formatDateTime } from '../../utils/format';

export const AgentWallet: React.FC = () => {
  const [wallet, setWallet] = useState<Wallet | null>(null);
  const [txns, setTxns] = useState<WalletTransaction[]>([]);

  useEffect(() => {
    getWallet().then(r => setWallet(r.data));
    getTransactions().then(r => setTxns(r.data.results || r.data));
  }, []);

  return (
    <div>
      <h1 style={{ fontSize: 20, fontWeight: 500, marginBottom: 20 }}>Wallet Saya</h1>
      {wallet && (
        <div style={{ background: '#f8f8f7', border: '0.5px solid rgba(0,0,0,0.1)', borderRadius: 12, padding: 24, textAlign: 'center', marginBottom: 20 }}>
          <div style={{ fontSize: 12, color: '#888780', marginBottom: 6 }}>Saldo tersedia</div>
          <div style={{ fontSize: 36, fontWeight: 500 }}>{formatCurrency(wallet.balance, wallet.currency)}</div>
          <div style={{ fontSize: 12, color: '#888780', marginTop: 4 }}>{wallet.currency}</div>
        </div>
      )}
      <Card title="Riwayat transaksi">
        <Table headers={['Waktu', 'Tipe', 'Jumlah', 'Referensi']}>
          {txns.map(t => (
            <Tr key={t.id}>
              <Td style={{ fontSize: 11, color: '#888780' }}>{formatDateTime(t.created_at)}</Td>
              <Td><Badge status={t.type === 'credit' ? 'confirmed' : 'cancelled'} label={t.type} /></Td>
              <Td style={{ fontWeight: 500, color: t.type === 'credit' ? '#3B6D11' : '#A32D2D' }}>
                {t.type === 'credit' ? '+' : '−'}{formatCurrency(t.amount)}
              </Td>
              <Td style={{ fontSize: 11, color: '#888780', fontFamily: 'monospace' }}>{t.reference_type}</Td>
            </Tr>
          ))}
          {txns.length === 0 && <Tr><Td style={{ color: '#888780', textAlign: 'center', padding: '20px 8px' }}>Belum ada transaksi</Td></Tr>}
        </Table>
      </Card>
    </div>
  );
};
